export enum AreaType {
  Circle = "Circle",
  Rectangle = "Rectangle",
  Polygon = "Polygon",
  ZipCodes = "ZipCodes",
  Multiple = "Multiple",
  Point = "Point"
}
